module.exports = __webpack_public_path__ + "img/logo-56.f75e888c.png";